<template>
  <select
    :id="selectId"
    class="form-control subject-input-select form-subject-type"
    v-model="inputValue"
    @change="emit($event)"
    @input="emit($event)"
    :disabled="disabled"
    :title="selectedItemName"
  >
    <option
      v-for="item in computedItems"
      v-bind:key="getItemKey(item)"
      :value="getItemValue(item)"
    >{{ getItemLabel(item) }}
    </option>
  </select>
</template>

<script>
import applicationInputMixin from '@/common/mixins/applicationInputMixin'
import applicationFormMixin from '@/common/mixins/applicationFormMixin'

export default {
  name: 'BaseSelect',

  mixins: [
    applicationInputMixin,
    applicationFormMixin
  ],

  props: {
    inputLabel: {
      type: String,
      default: 'Выберите значение'
    },

    inputName: {
      type: String,
      default: 'select_id'
    },

    items: {
      type: Array,
      default: () => []
    },

    disabled: {
      type: Boolean,
      default: false
    },

    modelValue: {
      type: [String, Number],
      default: ''
    },

    itemKey: {
      type: String,
      default: 'id'
    },

    itemValue: {
      type: String,
      default: 'id'
    },

    itemLabel: {
      type: String,
      default: 'name'
    },

    itemFilter: {
      type: Function,
      default: null
    },

    selectId: {
      type: String,
      default: () => `select-${Math.random().toString(36).substr(2, 9)}`
    }
  },

  emits: ['update:modelValue'],

  computed: {
    computedItems() {
      let items = this.items

      if (this.itemFilter && typeof this.itemFilter === 'function') {
        items = this.itemFilter(items)
      }

      return items
    },

    selectedItemName() {
      const selectedItem = this.items.find((item) => this.getItemValue(item) === this.inputValue)
      return selectedItem ? this.getItemLabel(selectedItem) : this.inputValue
    }
  },

  methods: {
    getItemKey(item) {
      return item[this.itemKey]
    },

    getItemValue(item) {
      return item[this.itemValue]
    },

    getItemLabel(item) {
      return item[this.itemLabel]
    },

    emit(event) {
      this.$emit('update:modelValue', event.target.value)
    }
  }
}
</script>
